export const TRACKING_SEQUENCE = [
  "pending",
  "processing",
  "ready_for_delivery",
  "delivered",
  "cancelled",
];

export const enrichOrderTracking = (order) => {
  if (!order || typeof order !== "object") return null;

  const status = order.status;

  return { ...order, status, tracking_status: status };
};
